// Google Play Billing directo via cordova-plugin-purchase
// $0 costo - sin intermediarios

const API_URL = process.env.REACT_APP_API_URL;

// Product IDs que creás en Google Play Console > Monetización > Productos in-app
const PRODUCTS = [
  { id: 'coins_basic_600', type: 'consumable', coins: 600 },
  { id: 'coins_pro_2000', type: 'consumable', coins: 2000 },
  { id: 'coins_elite_5000', type: 'consumable', coins: 5000 }
];

const PACKAGE_TO_PRODUCT = {
  basic: 'coins_basic_600',
  pro: 'coins_pro_2000',
  elite: 'coins_elite_5000'
};

let store = null;
let initialized = false;
let purchaseResolver = null;
let purchaseRejecter = null;

function getStore() {
  if (!store && window.CdvPurchase) {
    store = window.CdvPurchase.store;
  }
  return store;
}

export async function initPurchases() {
  if (initialized) return;
  const s = getStore();
  if (!s) {
    console.warn('CdvPurchase no disponible');
    return;
  }

  const { Platform, ProductType } = window.CdvPurchase;

  // Registrar productos
  s.register(PRODUCTS.map(p => ({
    id: p.id,
    type: ProductType.CONSUMABLE,
    platform: Platform.GOOGLE_PLAY
  })));

  // Cuando Google verifica la compra
  s.when().approved(async (transaction) => {
    try {
      const token = localStorage.getItem('token');
      const productId = transaction.products?.[0]?.id || transaction.productId;
      const productInfo = PRODUCTS.find(p => p.id === productId);

      const res = await fetch(`${API_URL}/coins/verify-google`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          productId,
          purchaseToken: transaction.purchaseId || transaction.transactionId,
          coins: productInfo?.coins || 0
        })
      });

      if (res.ok) {
        const data = await res.json();
        transaction.finish();
        if (purchaseResolver) {
          purchaseResolver(data);
          purchaseResolver = null;
          purchaseRejecter = null;
        }
      } else {
        transaction.finish();
        if (purchaseRejecter) {
          purchaseRejecter(new Error('Error verificando compra en servidor'));
          purchaseResolver = null;
          purchaseRejecter = null;
        }
      }
    } catch (e) {
      transaction.finish();
      if (purchaseRejecter) {
        purchaseRejecter(e);
        purchaseResolver = null;
        purchaseRejecter = null;
      }
    }
  });

  // v13 de cordova-plugin-purchase: usar transactionStateUpdated para detectar cancelaciones
  s.when().finished((transaction) => {
    if (transaction.state === window.CdvPurchase.TransactionState.CANCELLED) {
      if (purchaseRejecter) {
        purchaseRejecter(new Error('Compra cancelada'));
        purchaseResolver = null;
        purchaseRejecter = null;
      }
    }
  });

  s.error((error) => {
    console.error('Store error:', error);
    if (purchaseRejecter) {
      purchaseRejecter(new Error(error.message || 'Error en la compra'));
      purchaseResolver = null;
      purchaseRejecter = null;
    }
  });

  await s.initialize([Platform.GOOGLE_PLAY]);
  initialized = true;
}

export async function purchasePackage(packageId) {
  await initPurchases();
  const s = getStore();
  if (!s) throw new Error('Tienda no disponible');

  const productId = PACKAGE_TO_PRODUCT[packageId];
  if (!productId) throw new Error('Paquete no válido');

  const product = s.get(productId);
  if (!product) throw new Error('Producto no encontrado en Google Play');

  const offer = product.getOffer();
  if (!offer) throw new Error('Oferta no disponible');

  return new Promise((resolve, reject) => {
    purchaseResolver = resolve;
    purchaseRejecter = reject;
    s.order(offer).catch(err => {
      purchaseResolver = null;
      purchaseRejecter = null;
      reject(err);
    });
  });
}

export function getProductPrice(packageId) {
  const s = getStore();
  if (!s) return null;
  const productId = PACKAGE_TO_PRODUCT[packageId];
  const product = s.get(productId);
  return product?.pricing?.price || null;
}
